// A take named to a person wherever the screen knows only its number: the
// time it was recorded and the model (src/shared/takeStamp.js), fetched once
// per take from /api/tasks/takes and kept for the page. A number alone says
// nothing (23.10.2026: «#1127 — when was it made?»).
import React, { useEffect, useState } from 'react';
import { api } from './api';
import { takeStamp } from '../../shared/takeStamp';

const known = new Map();      // id -> {recordedAt, model}
const pending = new Set();    // asked for, not answered yet
const listeners = new Set();  // mounted hooks, bumped when stamps land
let timer = null;

function flush() {
  timer = null;
  const ids = [...pending];
  pending.clear();
  if (!ids.length) return;
  api.takes(ids).then((m) => {
    for (const id of ids) known.set(id, (m && m[id]) || {});
    listeners.forEach((l) => l());
  }).catch(() => { /* asked again by the next mount */ });
}
export function askStamps(ids) {
  let asked = false;
  for (const raw of ids || []) {
    const id = Number(raw);
    if (!Number.isInteger(id) || id <= 0 || known.has(id) || pending.has(id)) continue;
    pending.add(id);
    asked = true;
  }
  if (asked && !timer) timer = setTimeout(flush, 30);
}
// The stamp as known now (the number alone until the fetch lands).
export function stampText(id, opts) {
  const n = Number(id);
  if (!Number.isInteger(n) || n <= 0) return '';
  const s = known.get(n) || {};
  return takeStamp({ versionId: n, recordedAt: s.recordedAt, model: s.model }, opts);
}
// -> stampText, re-rendering the caller once the stamps of `ids` land.
export function useTakeStamps(ids) {
  const [, bump] = useState(0);
  const key = (ids || []).filter((x) => Number.isInteger(Number(x)) && Number(x) > 0).map(Number).join(',');
  useEffect(() => {
    const l = () => bump((n) => n + 1);
    listeners.add(l);
    askStamps(key ? key.split(',') : []);
    return () => listeners.delete(l);
  }, [key]);
  return stampText;
}
export function TakeRef({ id, reused = false }) {
  const t = useTakeStamps([id]);
  return id ? <>{t(id, { reused })}</> : null;
}
